var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../AppState';
import { buildCompositeAddress, fillSuffixFields, messageRotator, } from './helperFunctions';
import getServiceQualificationManual from './getServiceQualificationManual';
import getServiceUnavailable from './getServiceUnavailable';
import addressFieldsModel from '../models/addressFieldsModel';
import checkServicesAvailable from './checkServicesAvailable';
import onePlatformCheckServicesAvailable from './one_platform/onePlatformCheckServicesAvailable';
import { checkActiveServiceStatus } from "./one_platform/onePlatformGetServiceQualification";
import onePlatformAlreadyActiveService from "./one_platform/onePlatformAlreadyActiveService";
/**
 * Retrieves the service qualification  for a manually entered address.
 *
 * @param {Address} addressValues - The address values to check qualification for.
 * @returns {Promise<void>} - A promise that resolves once the service
 *                            qualification has been retrieved.
 */
const getAddressServiceQualificationManual = (addressValues) => __awaiter(void 0, void 0, void 0, function* () {
    const addressReconfirmed = document.createElement('p');
    addressReconfirmed.setAttribute('id', 'address-reconfirmed');
    const requiredAddressFields = addressFieldsModel;
    const serviceAddressObjectFiltered = {};
    requiredAddressFields.forEach(field => serviceAddressObjectFiltered[field] = addressValues[field]);
    fillSuffixFields(addressValues, 'LevelNumberSuffix', 'LevelNumber');
    fillSuffixFields(addressValues, 'StreetNumber1Suffix', 'StreetNumber');
    fillSuffixFields(addressValues, 'UnitSuffix', 'UnitNumber');
    if (!addressValues.Composite) {
        addressValues['Composite'] = buildCompositeAddress(addressValues);
    }
    addressReconfirmed.innerText = addressValues['Composite'];
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const currentlyConfirmed = context.querySelector('#address-confirmation-2');
    let displayedTile;
    displayedTile = context.querySelector('#address-tile');
    if (!displayedTile) {
        displayedTile = context.querySelector('#multi-address-tile');
        const addressConfirmed = currentlyConfirmed.querySelector('#address-confirmed');
        const addressReconfirmed = currentlyConfirmed.querySelector('#address-reconfirmed');
        if (addressConfirmed) {
            addressConfirmed.remove();
        }
        if (addressReconfirmed) {
            addressReconfirmed.remove();
        }
    }
    const addressCheckProgress = context.querySelector('#address-check-progress');
    // Update the display to move to the next step.
    currentlyConfirmed.appendChild(addressReconfirmed);
    const tileElements = displayedTile.querySelectorAll('.multi-address-tile--confirmation');
    tileElements.forEach((element) => element.remove());
    displayedTile.style.display = 'none';
    addressCheckProgress.style.display = 'block';
    messageRotator();
    // Check plan eligibility for address.
    try {
        const { serviceQualification, onePlatformServiceQualification, address, salesId, token, } = yield getServiceQualificationManual(addressValues);
        AppState.set('salesId', salesId);
        AppState.set('token', token);
        AppState.set('addressCheckProgress', addressCheckProgress);
        if (checkActiveServiceStatus(onePlatformServiceQualification.qualificationResult)) {
            onePlatformAlreadyActiveService();
        }
        else {
            if (onePlatformServiceQualification) {
                AppState.set('addressConfirmed', addressReconfirmed);
                onePlatformCheckServicesAvailable(onePlatformServiceQualification);
            }
            else {
                if (serviceQualification) {
                    AppState.set('addressConfirmed', addressReconfirmed);
                    checkServicesAvailable(serviceQualification, address);
                }
                else {
                    AppState.set('addressConfirmed', currentlyConfirmed);
                    getServiceUnavailable();
                }
            }
        }
    }
    catch (error) {
        console.log('Error:', error);
    }
});
export default getAddressServiceQualificationManual;
